import { put } from 'redux-saga/effects'
import { MetaMaskActions } from 'primsell-shared-layer/features'

declare const window: Window | undefined

export function* checkMetaMaskSaga(): Generator {
  const role = (yield localStorage.getItem('role')) as string | null
  if (!role) {
    yield localStorage.setItem('role', 'fan')
  }
  yield put(MetaMaskActions.setIsMetamask(!!window?.ethereum))
}
